import React from 'react'
import { useLang } from '../context/LangContext'

export default function DynamicHeader({ userName, avatarUrl, onAvatarClick, bonusBalance = 0 }) {
    const { lang } = useLang()

    const getGreeting = () => {
        const hour = new Date().getHours()
        if (hour >= 5 && hour < 12) return lang === 'kk' ? 'Қайырлы таң' : lang === 'en' ? 'Good morning' : 'Доброе утро'
        if (hour >= 12 && hour < 18) return lang === 'kk' ? 'Қайырлы күн' : lang === 'en' ? 'Good afternoon' : 'Добрый день'
        if (hour >= 18 && hour < 22) return lang === 'kk' ? 'Қайырлы кеш' : lang === 'en' ? 'Good evening' : 'Добрый вечер'
        return lang === 'kk' ? 'Қайырлы түн' : lang === 'en' ? 'Good night' : 'Спокойной ночи'
    }

    return (
        <div style={{
            background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.95) 0%, rgba(249, 249, 247, 0.95) 100%)',
            backdropFilter: 'blur(20px)',
            WebkitBackdropFilter: 'blur(20px)',
            padding: '20px 20px 28px',
            borderBottom: '0.5px solid rgba(0, 0, 0, 0.05)',
            transition: 'all 0.3s ease',
            borderRadius: '0 0 24px 24px',
            boxShadow: '0 4px 12px rgba(0, 0, 0, 0.03)'
        }}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
            }}>
                {/* Greeting */}
                <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '4px'
                }}>
                    <div style={{
                        fontSize: '14px',
                        fontWeight: '500',
                        color: '#9A9890',
                        letterSpacing: '0.2px'
                    }}>
                        {getGreeting()}
                    </div>
                    <h1 style={{
                        fontSize: '24px',
                        fontWeight: '700',
                        margin: 0,
                        color: '#111',
                        letterSpacing: '-0.5px',
                        lineHeight: 1.2
                    }}>
                        {userName}
                    </h1>
                </div>

                {/* Avatar */}
                <button
                    onClick={onAvatarClick}
                    style={{
                        width: '44px',
                        height: '44px',
                        borderRadius: '50%',
                        border: '2.5px solid #FFFFFF',
                        background: avatarUrl
                            ? `url(${avatarUrl})`
                            : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        cursor: 'pointer',
                        transition: 'transform 0.2s cubic-bezier(0.4, 0, 0.2, 1)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '18px',
                        color: '#FFFFFF',
                        fontWeight: '700',
                        WebkitTapHighlightColor: 'transparent',
                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                        overflow: 'hidden'
                    }}
                    onTouchStart={(e) => e.currentTarget.style.transform = 'scale(0.9)'}
                    onTouchEnd={(e) => e.currentTarget.style.transform = 'scale(1)'}
                >
                    {!avatarUrl && userName.charAt(0).toUpperCase()}
                </button>
            </div>
        </div>
    )
}
